import { render, staticRenderFns } from "./withoutSidebar.vue?vue&type=template&id=f50a4784&"
import script from "./withoutSidebar.vue?vue&type=script&lang=js&"
export * from "./withoutSidebar.vue?vue&type=script&lang=js&"
import style0 from "./withoutSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports